import React from "react";

//import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";

import Typography from "@material-ui/core/Typography";

import Country from "../../atoms/Country/index";

const MonthNames = [
  "Januar",
  "Februar",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];
const dateFormat = date =>
  date
    ? `${date.substr(8, 2)}. ${
        MonthNames[parseInt(date.substr(5, 2), 10) - 1]
      } ${date.substr(0, 4)}`
    : null;

export default ({
  Identity,
  IdentityDocuments,
  Address,
  Emails,
  Email,
  Wallets
}) => {
  return (
    <Grid container spacing={10} style={{ marginTop: "1em" }}>
      <Grid item xs={12}>
        <Typography variant={"h5"}>Personal Information</Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <div style={{ borderLeft: "2px solid lightgrey", paddingLeft: "1em" }}>
          <Typography>
            {Identity.FirstName} {Identity.LastName}
          </Typography>

          <Typography>{Address.Street}</Typography>

          <Typography>
            {Address.ZIP} {Address.City},{" "}
            <Country name={Address.Country.name} />
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sm={4}>
        <div style={{ borderLeft: "2px solid lightgrey", paddingLeft: "1em" }}>
          <Typography>
            <Country name={Identity.Nationality.name} />
            <span> (Nationality)</span>
          </Typography>

          <Typography>
            {dateFormat(Identity.DateOfBirth)}
            <span> (Date of Birth)</span>
          </Typography>

          <Typography>
            {Emails && Emails.length > 0 ? Emails[0].Email : ""}
            {Email && Email}
          </Typography>
        </div>
      </Grid>
      <Grid item xs={12} sm={4}>
        <div style={{ borderLeft: "2px solid lightgrey", paddingLeft: "1em" }}>
          <Typography>
            Document Type:{" "}
            {IdentityDocuments.Type
              ? IdentityDocuments.Type
              : IdentityDocuments[0].Type}
          </Typography>

          <Typography>
            <span style={{ wordWrap: "break-word" }}>
              {Wallets && Wallets.length > 0 ? Wallets[0].Address : ""}
            </span>
            <span> (ERC20 Wallet)</span>
          </Typography>
        </div>
      </Grid>
    </Grid>
  );
};
